const LinksMovidesk = {
  CENTRA_DE_AJUDA: "https://ajuda.fortestecnologia.com.br/kb/pt-br/article/550230/novidades-da-versao-fortes-bi?menuId=54163-141153-550230&ticketId=&q=",
  CHAT_PESSOAL: "https://cdn.atendimen.to/widget/6245dfe412085ee51cf9bd3f727c4c17/current?onlyChat=1&fila=579852&v=2",
  CHAT_RH: "https://cdn.atendimen.to/widget/6245dfe412085ee51cf9bd3f727c4c17/current?onlyChat=1&fila=579736&v=2"
}

export default LinksMovidesk;